"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _styles = require("@mui/material/styles");
var _CLabel = _interopRequireDefault(require("./CLabel"));
const _excluded = ["className", "id", "selectedId", "onChange", "label", "hint", "color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const StyledRadio = (0, _styles.styled)(_Radio.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    height: theme.spacing(2),
    color: 'rgba(0, 0, 0, 0.54)',
    padding: theme.spacing(1),
    transition: 'none'
  };
});

/**
 * 単独ラジオボタン
 *
 * @prop {string,number} id -　ラジオボタンのID
 * @prop {string,number} selectedId -　現在選択されているID
 * @prop {func} onChange -　選択時のイベントハンドラ<br/>
 * シグネチャ：(id:(string,number)):void
 * @prop {string} [label] - ラベルに表示する文字列
 * @prop {string} [hint] - ヒントコンテンツのid。
 *
 */
const CRadio = props => {
  const {
      className,
      id,
      selectedId,
      onChange,
      label,
      hint,
      color
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, _extends({
    className: className,
    control: /*#__PURE__*/_react.default.createElement(StyledRadio, {
      checked: selectedId === id,
      id: String(id),
      color: color,
      disableRipple: true
    }),
    label: label ? /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label,
      hint
    }) : undefined,
    onChange: () => {
      onChange(id);
    }
  }, rest));
};
CRadio.propTypes = {
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  selectedId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  label: _propTypes.default.string,
  hint: _propTypes.default.string
};
var _default = exports.default = CRadio;